import { render, staticRenderFns } from "./cloud-service.vue?vue&type=template&id=0c642745&scoped=true"
import script from "./cloud-service.vue?vue&type=script&lang=js"
export * from "./cloud-service.vue?vue&type=script&lang=js"
import style0 from "./cloud-service.vue?vue&type=style&index=0&id=0c642745&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c642745",
  null
  
)

export default component.exports